import "../blocks/utils/block-hydration";
import "./slider-arrows.js";
import "./simple-accordion.js";
import "./js/accordion";
import "./vertical-slider.js";
// import "./notification-bar.js";
import "./shopify";
import "./notification.js";
import { resizeFn, setStickyOffset, toggleDestini } from "./js/utils";

if(document.querySelector('#tip-list')) {
	import('./tips');
}
/* search results logic */
if (document.querySelector(".page-template-searchpage")) {
	let checkboxes = document.querySelectorAll(".search-checkbox input");

	checkboxes.forEach(function (checkbox) {
		checkbox.addEventListener("change", function (e) {
			let checkboxes = document.querySelectorAll(".search-checkbox input");
			let articles = document.querySelectorAll(".search-results-article");
			articles.forEach(function (el) {
				el.classList.add("hidden");
			});

			checkboxes.forEach(function (chbox) {
				if (chbox.checked) {
					document
						.querySelectorAll(`[data-type=${chbox.id}]`)
						.forEach(function (el) {
							el.classList.remove("hidden");
						});
				}
			});
		});
	});
}

if (document.querySelector(".single-product")) {
	resizeFn();
	setTimeout(() => {
		resizeFn();
	}, 100);

	const sidebar = document.querySelector(".product-image");
	const sidebarTop = getComputedStyle(sidebar).top;
	const footer = document.querySelector(".additional-product-information");

	window.addEventListener("scroll", function () {
		let y = window.scrollY;
		let windowHeight = window.outerHeight;
		const footerTop = footer.offsetTop;
		let difference = y + windowHeight - footerTop - 350;

		if (difference > 0) {
			sidebar.style.top = parseInt(sidebarTop) - difference + "px";
		} else {
			sidebar.style.top = sidebarTop;
		}
	});

	/* window resize */
	window.addEventListener("resize", resizeFn);
}

/* destini modals */
var openmodal = document.querySelectorAll(".modal-open");
for (var i = 0; i < openmodal.length; i++) {
	openmodal[i].addEventListener("click", function (event) {
		event.preventDefault();
		toggleDestini();
	});
}

// let parentEl = document.getElementsByClassName("recipe-slider-wrapper");
// let childEl = document.getElementsByClassName("recipe-slider-flex");

// let parentElWdith = parentEl[0].offsetWidth;
// let childElWidth = childEl[0].scrollWidth;
// console.log("parentEL:", parentElWdith, "childEl:", childElWidth);

// if (childElWidth > parentElWdith) {
// 	console.log(true);
// } else {
// 	console.log(false);
// 	childEl[0].classList.add("justify-center");
// }

if (document.querySelector("#product-schema-data")) {
	import("./product-schema.js");
}

setStickyOffset()
